import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown, ArrowRight } from 'lucide-react';
import { CopyLinkButton } from './CopyLinkButton';
import { getEntry, entryPathById } from '../../utils/guideIndex';
import type { GuideFaq } from '../../types/guide';
function FaqItem({
  faq,
  linkable
}: {
  faq: GuideFaq;
  linkable: boolean;
}) {
  const {
    hash
  } = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (hash === `#${faq.id}`) setOpen(true);
  }, [hash, faq.id]);
  const related = faq.related.filter((r, i, arr) => arr.findIndex(x => x.entryId === r.entryId) === i && getEntry(r.entryId));
  return <li id={linkable ? faq.id : undefined} className="scroll-mt-28 rounded-2xl" data-id="element-388" data-mp="dwgki7cn743v">
      <div className="flex items-start gap-2" data-id="element-389" data-mp="du42ju6vwtqt">
        <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} className="flex min-h-[52px] flex-1 items-center justify-between gap-4 py-3 text-left" data-id="element-390" data-mp="3w34lbl0nt53q">
          <span className="font-semibold text-white text-[15px] md:text-base" data-id="element-391" data-mp="3u42xb9jww7uq">{faq.question}</span>
          <ChevronDown className={`h-5 w-5 shrink-0 text-[#D4AF37] transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-392" data-mp="3p61cok6u80h5" />
        </button>
        {linkable && <div className="pt-2" data-id="element-393" data-mp="234zg0w0ckdt"><CopyLinkButton hash={faq.id} iconOnly label="Copiar enlace a esta pregunta" data-id="element-394" data-mp="22my4puhnfz1" /></div>}
      </div>
      {open && <div className="pb-5 pr-2" data-id="element-395" data-mp="36g1u8g5i5jmp">
          <p className="text-[15px] md:text-base text-gray-300 leading-relaxed" data-id="element-396" data-mp="36h35akmiq64f">{faq.answer}</p>
          {related.length > 0 && <ul className="mt-3 flex flex-wrap gap-2" data-id="element-397" data-mp="3k8rhsp0oiwlx">
              {related.map(r => <li key={r.entryId} data-id="element-398" data-mp="3fff4hb1gac8h">
                  <Link to={entryPathById(r.entryId, r.sectionId)} className="inline-flex h-9 items-center gap-1.5 rounded-full bg-white/5 px-3.5 text-sm font-semibold text-[#D4AF37] transition-colors duration-150 hover:bg-white/10" data-id="element-399" data-mp="2rr5k8djvxwjg">
                    {getEntry(r.entryId)?.title}
                    <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" data-id="element-400" data-mp="vmptpbe9ywon" />
                  </Link>
                </li>)}
            </ul>}
        </div>}
    </li>;
}
export function FaqList({
  faqs,
  linkable = false
}: {
  faqs: GuideFaq[];
  linkable?: boolean;
}) {
  return <ul className="divide-y divide-white/10 border-y border-white/10" data-id="element-401" data-mp="7rmse3yab0ra">
      {faqs.map(f => <FaqItem key={f.id} faq={f} linkable={linkable} data-id="element-402" data-mp="cpy28eokxb9i" />)}
    </ul>;
}